module.exports = __webpack_public_path__ + "img/2.4bf01708.png";